<template>
  <div id="app">
    <main-header />
    <main>
      <section class="container-fluid" id="about">
        <div class="container hero">
          <div class="row mb-5">
            <div class="col-md-8">
              <h1 class="text-uppercase" data-aos="fade-up">
                Бизнес <br />
                по-одесски<span class="text--primary">.</span>
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 order-1 order-md-0" data-aos="fade-up">
              <p>
                Эта книга – об Одессе, о любви к еде и к жизни, о ресторанном
                бизнесе и о деньгах: заработанных и потерянных. Она написана для
                всех, кто занимается и думает заниматься бизнесом, любит Одессу
                и ценит ироничный взгляд на мир, а также для рестораторов -
                настоящих и будущих. В своей книге я рассказываю о том, как
                строил и продолжаю строить свою жизнь и свой бизнес. Я стремился
                к тому, чтобы эта история получилась честной, вдохновляющей и,
                конечно, очень одесской.
              </p>
              <img src="@/assets/images/sign.svg" alt="" class="img-fluid" />
            </div>
            <div class="col-md-6 offset-md-2 box order-0 order-md-1">
              <div class="box__inner"></div>
              <img
                src="@/assets/images/libkin.png"
                alt=""
                class="img-fluid d-md-none"
              />
              <div class="hero__cta-content d-md-none">
                <h3 class="mb-5">Савва подпишет книгу лично Вам!</h3>
                <div class="w-100 text-end mb-3">
                  <h6 class="mb-0">Стоимость книги: 270грн.</h6>
                  <small class="text--grey"
                    >*стоимость доставки рассчитывается при оформлении
                    заказа</small
                  >
                </div>
                <div class="d-flex flex-column flex-md-row">
                  <main-input
                    class="w-100 me-5"
                    placeholder="Кому подписать?"
                    v-model="sign"
                    ref="phone"
                    type="tel"
                    required
                  />
                  <button-simple primary @click="isModalActive = true">
                    Заказать
                  </button-simple>
                </div>
              </div>
              <parallax-container class="d-none d-md-block">
                <parallax-element :factor="-0.4">
                  <img
                    src="@/assets/images/libkin.png"
                    alt=""
                    class="img-fluid"
                  />
                </parallax-element>
              </parallax-container>
            </div>
          </div>
          <div class="row justify-content-center d-none d-md-flex">
            <div class="col-md-8 hero__cta py-5">
              <div class="hero__cta-content">
                <h3>Савва подпишет книгу лично Вам!</h3>
                <div class="w-100 text-end mb-3">
                  <h6 class="mb-0">Стоимость книги: 270грн.</h6>
                  <small class="text--grey"
                    >*стоимость доставки рассчитывается при оформлении
                    заказа</small
                  >
                </div>
                <div class="d-flex flex-column flex-md-row">
                  <main-input
                    class="w-100 me-5"
                    placeholder="Кому подписать?"
                    v-model="sign"
                    ref="phone"
                    type="tel"
                    required
                  />
                  <button-simple primary @click="isModalActive = true">
                    Заказать
                  </button-simple>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="container-fluid authors mb-5" id="authors">
        <div class="container">
          <div class="row">
            <div
              class="col-md-8 offset-md-2 mb-5"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1000"
            >
              <div class="row">
                <div class="col-12">
                  <h2 class="mb-3">
                    Про авторов<span class="text--primary">.</span>
                  </h2>
                </div>
              </div>
              <div class="row align-items-center mb-3">
                <div class="col-md-3">
                  <img
                    src="@/assets/images/libk.jpg"
                    alt=""
                    class="img-fluid mb-3"
                  />
                </div>
                <div class="col-md-9">
                  <h3>Савва Либкин</h3>
                  <p class="mb-3">
                    Успешный украинский ресторатор. Основатель компании
                    «Рестораны Саввы Либкина», владелец ресторанов «Дача»,
                    «Тавернетта», сети кафе «Компот». Колумнист и автор
                    бестселлеров «Моя Одесская кухня» и «Одесское застолье от
                    Привоза до Дерибасовской». Визионер ресторанной премии
                    «Соль». Хранитель традиций одесской кухни и ценитель
                    одесского стиля жизни.
                  </p>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-md-3">
                  <img
                    src="@/assets/images/fril.jpg"
                    alt=""
                    class="img-fluid mb-3"
                  />
                </div>
                <div class="col-md-9">
                  <h3>Антон Фридлянд</h3>
                  <p>
                    Киевский писатель и журналист. Автор семи книг, среди
                    которых – "Запах шахмат", "День Банана" и "Дорогое
                    удовольствие". Давно влюблен в Одессу и считает ее своим
                    вторым домом.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="container-fluid reviews mb-5" id="about-savva">
        <div class="container">
          <!-- <div class="row mt-5">
            <div class="col-md-6 square text-center">
              <div class="square__inner"></div>
              <parallax-container>
                <parallax-element :factor="-0.3">
                  <img
                    src="@/assets/images/person.png"
                    alt=""
                    class="img-fluid"
                  />
                </parallax-element>
              </parallax-container>
            </div>
            <div class="col-md-4" data-aos="fade-up" data-aos-offset="500">
              <h2 class="my-3">
                История. Савва. Драйв<span class="text--primary">.</span>
              </h2>
              <p class="mb-3">
                "Мы дружим с Саввой – страшно сказать как долго – наверно, уже
                лет пятнадцать. Несколько лет назад я даже успел поработать его
                PR-директором, а также выступил редактором обеих его книг.
                Поэтому когда он предложил мне помочь ему написать историю его
                жизни, я долго не раздумывал. Прежде мне не приходилось
                выступать чьим-то биографом, но в случае с Саввой наша работа
                над книгой превратилась в очень драйвовый, веселый процесс".
              </p>
              <h4>Антон Фридлянд</h4>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <h2 class="my-3">
                Друзья о Савве<span class="text--primary">.</span> <br />
              </h2>
            </div>
          </div>
          <div class="row mb-5">
            <div
              class="col-md-8 offset-md-2"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1000"
            >
              <p>
                <b>"</b> Одессит – самый требовательный клиент мира. Это я
                утверждаю ответственно, так как сам в Одессе вырос. С форшмаком
                матери каждый житель нашего города впитал высочайший уровень
                качества и вкуса пищи. И всю дальнейшую жизнь, в какой бы стране
                не оказался, он ищет чтоб хотя бы не перемаслено, уже молчим о
                том, чтобы близко к домашнему. Попытка читателя оценить деловой
                путь Саввы Либкина будет неудачной без понимания описанной выше
                тонкости. Помните, что Савве удалось накормить людей с
                максимально высоким уровнем придирчивости к каждому помидору в
                салате. Если уж покорил эту высоту, дальше перед тобой открыты
                все пути, и я от души желаю моему дорогому другу процветания.<b
                  >"</b
                >
              </p>
              <h3>-Андрей Ставницер</h3>
            </div>
          </div>
          <div class="row mb-5">
            <div
              class="col-md-8 offset-md-2 text-end"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1000"
            >
              <p>
                <b>"</b>Первые две книги Саввы были с рецептами. Но он не только
                повар, не только бизнесмен. Он художник. Поэтому к каждому
                ресторану, каждому блюду и почти к каждой фразе он относится как
                к творческому акту. Поэтому в ресторанах не только красиво, но и
                интересно. Вкусно. В любых обстоятельствах. Книга это коллекция
                абсолютно одесских вызовов, ситуаций, находок и персонажей,
                переживаний и достижений. Не только передаёт дух времени, но так
                же содержит рецепты. Правда не блюд, а жизни.<b>"</b>
              </p>
              <h3>-Андрей Федорив</h3>
            </div>
          </div>
          <div class="row mb-5">
            <div
              class="col-md-8 offset-md-2"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1000"
            >
              <p>
                <b>"</b>В Одессу едут за морем, атмосферой, слушать как говорят
                местные жители и за одесской кухней. Савва Либкин и его
                гастрономические проекты "Компот", "Тавернетта" и "Дача" - часть
                этого явления. Рестораны Одесской кухни можно встретить в
                Нью-Йорке, Хабаровске, Тель-Авиве, Киеве и Берлине. Это
                единственная кухня имени Города, где она родилась, все остальные
                кухни имени стран - китайская, мексиканская, итальянская. Я
                прочитал книгу с удовольствием, она интересна, после неё
                отличное послевкусие, и хочется пить чай с черешневым вареньем в
                "Даче", читать эту книгу, размышлять и делать выводы. Когда
                Одесса и "Дача" временно недоступны, можно просто открыть эту
                книгу в любой части мира и представить, что ты уже там.<b>"</b>
              </p>
              <h3>-Евгений Черняк</h3>
            </div>
          </div>
          <div class="row my-5">
            <div
              class="col-md-8 offset-md-2 text-end"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1000"
            >
              <p>
                <b>"</b>Савва появился в Ассоциации Владельцев Семейных компаний
                5 лет назад. За это время Савва проявил себя предпринимателем,
                который создал бизнес не столько для себя, сколько для
                коммьюнити. Все кто хоть рах приехали в Одессу, ассоциируют наш
                город, в том числе с Дачей и Компотом. И Савва был бы счастлив,
                если бы его семья и дети разделили его страсть и смогли бы со
                временем подхватить его дело всей жизни! Савва не боится
                учиться. Никогда не стесняется признать свои ошибки или сказать
                если чего-то не знает. Савва умеет привлекать учителей. И сейчас
                проходит сложный процесс передачи и делегирования своего бизнеса
                профессиональному менеджменту. Этот процесс требует мужества и
                времени. Уверен, что Савва с этим справится и отойдя от
                операционки станет строителем идеологии великого бизнеса,
                который сделает популярным одесскую кухню во всем мире!<b>"</b>
              </p>
              <h3>-Владислав Бурда</h3>
            </div>
          </div>
        </div>
      </section>
      <section class="container-fluid get-book mb-5" id="order">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center mb-5">
              <h2>
                Закажите книгу с подписью прямо сейчас<span
                  class="text--primary"
                  >.</span
                >
              </h2>
            </div>
            <div class="col-md-7">
              <div class="me-md-5">
                <img
                  src="@/assets/images/Mockup_Lubkin-2.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
            <div
              class="col-md-4 mb-5 d-flex flex-column justify-content-center"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1000"
            >
              <h3 class="mb-5">
                Книга с автографом автора. Напишите кому и Савва подпишет лично
                Вам!
              </h3>
              <main-input
                class="mb-5"
                placeholder="Ваша подпись"
                v-model="sign"
                ref="phone"
                type="tel"
                required
              />
              <div
                class="d-flex justify-content-between align-items-center w-100 mb-3"
              >
                <h6 class="mb-0">Стоимость книги: 270грн.</h6>
                <button-simple primary @click="isModalActive = true"
                  >Заказать</button-simple
                >
              </div>
              <div class="mb-3">
                <small class="text--grey"
                  >*стоимость доставки рассчитывается при оформлении
                  заказа</small
                >
              </div>
            </div>
          </div>
        </div>
      </section>
      <main-form v-model="isModalActive" :sign="sign" />
    </main>
  </div>
</template>
<script>
import mainHeader from "@/components/mainHeader.vue";
import parallaxContainer from "@/components/parallaxContainer.vue";
import parallaxElement from "@/components/parallaxElement.vue";
import buttonSimple from "@/components/buttonSimple.vue";
import mainInput from "@/components/mainInput.vue";
import mainForm from "@/components/mainForm.vue";
export default {
  name: "App",
  components: {
    mainHeader,
    parallaxContainer,
    parallaxElement,
    mainHeader,
    buttonSimple,
    mainInput,
    mainForm,
  },
  data() {
    return {
      sign: "",
      isModalActive: false,
    };
  },
  // methods: {
  //   loadNPScript() {
  //     let scriptElement = document.createElement("script");
  //     scriptElement.setAttribute(
  //       "src",
  //       "https://apimgmtstorelinmtekiynqw.blob.core.windows.net/content/MediaLibrary/Widget/Calc/dist/calc.min.js"
  //     );
  //     scriptElement.id = "calc";
  //     scriptElement.setAttribute("apiKey", "03af9d52a9bfb46bebeeba683f373ad8");
  //     scriptElement.dataset.lang = "ua";
  //     scriptElement.dataset.town = "city-not-default";
  //     scriptElement.dataset.townName = "undefined";
  //     scriptElement.dataset.townId = "undefined";
  //     console.log(scriptElement);
  //     document.body.appendChild(scriptElement);
  //   },
  // },
  //  mounted() {
  //   // this.loadNPScript();

  //   // const scriptElement = document.createElement("script");
  //   // scriptElement.
  // },
};
</script>
<style lang="scss">
@import "@/stylesheets/main.scss";
.box {
  position: relative;
  @media screen and (min-width: 768px) {
    &__inner {
      content: "";
      display: block;
      background: $secondary;
      width: 100%;
      height: 100%;
      max-height: 500px;
      max-width: 500px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    }
  }
}
.square {
  position: relative;
  @media screen and (min-width: 768px) {
    &__inner {
      content: "";
      display: block;
      background: $secondary;
      width: 100px;
      height: 100px;
      position: absolute;
      top: 15%;
      left: 15%;
      z-index: 0;
    }
  }
}
.hero {
  padding-top: 80px;
  position: relative;
  &__cta {
    @media screen and (min-width: 996px) {
      position: absolute;
      bottom: 15vh;
    }

    &-content {
      box-shadow: 3px 3px 15px rgba(105, 105, 105, 0.05);
      background: $light;
      padding: 15px;
      position: relative;
      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 50px;
        height: 50px;
        background: $secondary;
        z-index: -1;
      }
      &::before {
        top: -25px;
        left: -25px;
      }
      /* &::after {
        display: none;
        right: -25px;
        bottom: -25px;
      } */
    }
  }
}
.authors {
  @media screen and (min-width: 768px) {
    margin-top: -15vh;
  }
}
</style>
